import React from "react";
import {
  Container,
  VStack,
  Heading,
  Text,
  Button,
  Icon,
} from "@chakra-ui/react";
import { FiCheckCircle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const OrderSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxW="600px" py={16}>
      <VStack spacing={8} align="center">
        <Icon as={FiCheckCircle} w={20} h={20} color="green.500" />
        <Heading textAlign="center">Order Successful!</Heading>
        <Text fontSize="lg" textAlign="center" color="gray.600">
          Thank you for your purchase. Your order has been successfully
          processed.
        </Text>
        <Button colorScheme="blue" size="lg" onClick={() => navigate("/")}>
          Continue Shopping
        </Button>
      </VStack>
    </Container>
  );
};

export default OrderSuccess;
